// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/nexus/agents/agents.actions.go

import { type Scope } from "~/hooks/useScope";
import { GENERATE_REGISTRATION_TOKEN } from "./action";

export function canGenerateRegistrationToken(scope: Scope): boolean {
  return scope.iamActions.includes(GENERATE_REGISTRATION_TOKEN);
}
